/*

1)  outside the pattern: when a data-focussed-dialog-close-url or
    data-focussed-dialog-prev-url attribute is given, we add the current location to the hyperlink
2)  render close button href and prev anchor href, when search parameters in url are given

 */

window.o_global.eventQBus.on(
  "assets.focusseddialog.init",
  (windowLocationSearch, windowLocationHref, target = document.querySelector("body")) => {
    const prefix = "js-";

    const selectors = {
      closeAttribute: "data-focussed-dialog-close-url",
      prevAttribute: "data-focussed-dialog-prev-url",
      addClose: `.${prefix}pl_focussed-dialog__add-closeUrl`,
      addPrev: `.${prefix}pl_focussed-dialog__add-prevUrl`,
      closeLink: `a.${prefix}pl_focussed-dialog__closeUrl`,
      prevLink: `a.${prefix}pl_focussed-dialog__prevUrl`,
      dialog: `.${prefix}pl_focussed-dialog`,
      hideInApp: `.${prefix}pl_focussed-dialog--hideInApp`,
    };

    const closeQueryName = "focussedDialogCloseUrl";
    const prevQueryName = "focussedDialogPrevUrl";

    const utils = {
      /* due to ie11 we can't use URLSearchParams */
      getValueFromQueryString: (queryString, parameterName) => {
        const vars = queryString.split("&");
        let res;
        vars.forEach((v) => {
          const equalPosition = v.indexOf("=");
          const value = v.slice(equalPosition + 1);
          const key = v.replace(`=${value}`, "");
          if (key === parameterName) {
            res = value;
          }
        });
        return res;
      },
      getUrlObject: (url) => {
        // we can't use new URL() due to IE11 https://caniuse.com/url
        const a = document.createElement("a");
        a.href = url;

        /* 🤯 https://stackoverflow.com/a/13405933/408668 */

        // eslint-disable-next-line no-self-assign
        a.href = a.href;
        return a;
      },
      encode: (str) => {
        return encodeURIComponent(str);
      },
      decode: (str) => {
        return decodeURIComponent(str);
      },
      createRelativeLink: (url) => {
        const { pathname, search, hash } = utils.getUrlObject(url);
        const relativeUrl = `${pathname.indexOf("/") !== 0 ? "/" : ""}${pathname}${search}${hash}`;
        return relativeUrl;
      },
      getURLwithExtendedSearch: ({ pathname, search, hash, extraParams = "" }) => {
        const extended = `${search ? `${search}&` : "?"}${extraParams}`;

        const newUrl = `${pathname.indexOf("/") !== 0 ? "/" : ""}${pathname}${extended}${hash}`;
        return newUrl;
      },
      appendQueryToElement: (el, url, queryName) => {
        const tagName = el.tagName.toLowerCase();

        const { pathname, search, hash } = utils.getUrlObject(
          el.getAttribute("href") || el.getAttribute("action")
        );
        const extraParams = `${queryName}=${url}`;
        const newUrl = utils.getURLwithExtendedSearch({
          pathname,
          search,
          hash,
          extraParams,
        });

        if (tagName === "a") {
          el.setAttribute("href", newUrl);
        }
        if (tagName === "form") {
          el.setAttribute("action", newUrl);
        }
      },
      // prevent evil urls 🤞🏼
      isSafeUrl: (url) => {
        const { host, protocol, port } = utils.getUrlObject(url);
        let fixedHost = host;
        /*  good old IE11 has olways the port in the host
         *  we cut it, if we are running on port 443 or 80
         *  */
        if (port === "443" || port === "80") {
          const portInHostnamePos = host.indexOf(":");
          fixedHost = host.slice(0, portInHostnamePos);
        }
        const isSafe = fixedHost === window.location.host && protocol === window.location.protocol;
        // console.log("isSafe:", url, isSafe);
        return isSafe;
      },
    };

    /*

    hide all elements with class js-pl_focussed-dialog--hideInApp
    when the app cookie is set

     */

    [].forEach.call(target.querySelectorAll(selectors.dialog), (dialog) => {
      if (window.o_util.cookie.exists("app")) {
        const elementsToHide = dialog.querySelectorAll(selectors.hideInApp);
        dialog.classList.add("pl_focussed-dialog--inApp");

        [].forEach.call(elementsToHide, (el) => {
          // eslint-disable-next-line no-param-reassign
          el.style.display = "none";
        });
      }
    });

    // add close url to hyperlinks
    [].forEach.call(target.querySelectorAll(`a[${selectors.closeAttribute}]`), (el) => {
      const url = el.getAttribute(selectors.closeAttribute) || windowLocationHref;
      utils.appendQueryToElement(el, utils.encode(utils.createRelativeLink(url)), closeQueryName);
    });

    // add prev url to hyperlinks
    [].forEach.call(target.querySelectorAll(`a[${selectors.prevAttribute}]`), (el) => {
      const url = el.getAttribute(selectors.prevAttribute) || windowLocationHref;

      utils.appendQueryToElement(el, utils.encode(utils.createRelativeLink(url)), prevQueryName);
    });

    if (windowLocationSearch) {
      const closeLinks = document.querySelectorAll(selectors.closeLink);
      const prevLinks = document.querySelectorAll(selectors.prevLink);

      const prevUrl = utils.getValueFromQueryString(
        windowLocationSearch.substring(1),
        prevQueryName
      );

      const closeUrl = utils.getValueFromQueryString(
        windowLocationSearch.substring(1),
        closeQueryName
      );

      const addCloseElements = document.querySelectorAll(selectors.addClose);
      const addPrevElements = document.querySelectorAll(selectors.addPrev);

      if (prevUrl && utils.isSafeUrl(utils.decode(prevUrl))) {
        [].forEach.call(addPrevElements, (el) => {
          utils.appendQueryToElement(el, prevUrl, prevQueryName);
        });

        // change prev links url with the value from url
        [].forEach.call(prevLinks, (el) => {
          el.setAttribute("href", utils.decode(prevUrl));
        });
      }

      // do we have a closeUrl and it's safe?
      if (closeUrl && utils.isSafeUrl(utils.decode(closeUrl))) {
        // add focussedDialogCloseUrl=[URL] to all hyperlinks with the magic js class
        [].forEach.call(addCloseElements, (el) => {
          utils.appendQueryToElement(el, closeUrl, closeQueryName);
        });

        // change close links url with the value of focussedDialogCloseUrl from url
        [].forEach.call(closeLinks, (el) => {
          const extraParams = el.getAttribute("data-focussed-dialog-add-params");
          let url = utils.decode(closeUrl);
          if (extraParams) {
            const { pathname, search, hash } = utils.getUrlObject(url);
            url = utils.getURLwithExtendedSearch({
              pathname,
              search,
              hash,
              extraParams,
            });
          }

          el.setAttribute("href", url);
        });
      }
    }
  }
);

window.o_global.eventLoader.onAllScriptsExecuted(10, () => {
  window.o_global.eventQBus.emit(
    "assets.focusseddialog.init",
    window.location.search,
    window.location.href
  );
});
